import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import _ from 'lodash'
import moment from 'moment'
import Title from '../general/title'

class CommunityStats extends Component {

    buildTable = () => {
        var ret = []

        if(_.has(this.props, 'payload.builderSales')) {
            this.props.payload.builderSales.forEach((r) => {
                var v = {}
                v.salesperson = (_.has(this.props, `payload.salespeople[${r.salesperson}]`) ? this.props.payload.salespeople[r.salesperson].title : '' )
                v.address = r.address
                v.builder = this.props.payload.public.builders.builderChildren && this.props.payload.public.builders.builderChildren[r.builder_id]
                v.date = (r.sale_date ? r.sale_date : r.addedDate)

                ret.push(v)
            })
        }

        ret = _.sortBy(ret, 'date').reverse()

        return ret
    }

    buildTotalSales = () => {
        if(_.has(this.props, 'payload.builderSalesTotals.current')) {
            var keys = Object.keys(this.props.payload.builderSalesTotals.current)
            return keys.map((v, i) => {
                var total = this.props.payload.builderSalesTotals.current[v]
                return (
                    <li className="statBreakout__item" key={i}>
                        <div>
                            <div className="statBreakout__stat">{total}</div>
                            <div className="statBreakout__info">{this.props.payload.public.builders.builderChildren[v]}</div>
                        </div>
                    </li>
                )
            })
        }
    }

    render() {
        const columns = [
            {
                Header: 'Sales Person',
                accessor: 'salesperson'
            },
            {
                Header: 'Address',
                accessor: 'address'
            },
            {
                Header: 'Builder',
                accessor: 'builder'
            },
            {
                Header: 'Date',
                accessor: 'date',
                Cell: props => moment.unix(props.value).format('MM/DD/YY'),
                sort: 'desc'
            },
        ]

        return (
			<div className="sales">
				<Title title="Sales" />
				<div className="statBreakout">
					<div className="statBreakout__group">
						<ul className="statBreakout__list">{this.buildTotalSales()}</ul>
					</div>
				</div>
				<div className="recentActivity content">
					<h2>
						Sales for {this.props.currentDates.startText} - {this.props.currentDates.endText}
					</h2>
					<ReactTable data={this.buildTable()} loadingText="" columns={columns} defaultPageSize={10} />
				</div>
			</div>
		)
    }

}

function mapStateToProps(state) {
    return {
        currentDates: state.currentDates,
        compareDates: state.compareDates,
        payload: state.payload
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(CommunityStats)